import * as React from 'react'

import { InputImage as InputImagePresenter, IProps } from './presenter'

export const InputImage = React.forwardRef<
  HTMLInputElement,
  Omit<IProps, 'setThumbnail'>
>(({ thumbnailUrl, ...props }, ref) => {
  const [thumbnail, setThumbnail] = React.useState(thumbnailUrl)

  return (
    <InputImagePresenter
      {...props}
      thumbnailUrl={thumbnail}
      setThumbnail={setThumbnail}
      ref={ref}
    />
  )
})

export default InputImage
